module.exports = __webpack_public_path__ + "img/amx-19.2c6599e5.jpg";